import React from "react"
import { SectionProps, withSection } from "@app/hoc/Section"
import { Box } from "@chakra-ui/react"

import CallToActionDesktop from "./CallToActionDesktop"
import CallToActionMobile from "./CallToActionMobile"

export type CallToActionProps = GatsbyTypes.SanitySectionCallToAction & SectionProps

const CallToAction = ({ innerRef, ...props }: CallToActionProps) => {
  return (
    <Box ref={innerRef}>
      <Box display={["none", "block"]}>
        <CallToActionDesktop {...props} />
      </Box>
      <Box display={["block", "none"]}>
        <CallToActionMobile {...props} />
      </Box>
    </Box>
  )
}

export default React.memo(withSection(CallToAction))
